;(function (angular, _) {
  'use strict'

  angular
  .module('kilo.common.directives')
  .directive('templateValidation', templateValidationDirective)

  templateValidationDirective.$inject = ['$q', 'InvoiceTemplateManager', 'QuoteTemplateManager', 'CreditNoteTemplateManager']

  function templateValidationDirective ($q, InvoiceTemplateManager, QuoteTemplateManager, CreditNoteTemplateManager) {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        function checkSameTemplate (def, found) {
          var total = parseInt(found.meta.total)
          if (total === 1) {
            _.map(found.data, '_id').includes(attrs.template) ? def.resolve() : def.reject()
          } else if (total === 0) {
            def.resolve()
          } else if (total > 1) {
            def.reject()
          }
        }

        ctrl.asyncValidators = ctrl.asyncValidators || {}
        var type = attrs.templateValidation
        ctrl.$asyncValidators[type] = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return $q.when()
          }
          var def = $q.defer()
          if (attrs.templateType === 'facture' || attrs.templateType === 'situation') {
            InvoiceTemplateManager.get(
              InvoiceTemplateManager.query()
              .select(viewValue, type))
              .then(function (found) {
                checkSameTemplate(def, found)
              })
          } else if (attrs.templateType === 'devis') {
            QuoteTemplateManager.get(
              QuoteTemplateManager.query()
              .select(viewValue, type))
              .then(function (found) {
                checkSameTemplate(def, found)
              })
          } else if (attrs.templateType === 'avoir') {
            CreditNoteTemplateManager.get(
              CreditNoteTemplateManager.query()
              .select(viewValue, type))
              .then(function (found) {
                checkSameTemplate(def, found)
              })
          }
          return def.promise
        }
      }
    }
  }
})(window.angular, window._)
